import { FlexProps } from "@biblioteksentralen/react";
import { useReducedMotion } from "framer-motion";

// We want to be able to customize transition-delay for relevant props without
// having to repeat these defaults everywhere. We specify transition-property
// in order not to transition props like width and height
const defaultTransitionProps = {
  transitionProperty: "color,background,fill",
  transitionTimingFunction: "ease-in-out",
  transitionDuration: "0.25s",
};

export const useTransitionProps = () => {
  const prefersReducedMotion = useReducedMotion();
  if (prefersReducedMotion) return {};
  return defaultTransitionProps;
};

type OneToSeven = 1 | 2 | 3 | 4 | 5 | 6 | 7;

// Predefined shuffled date and present color orders
export const adventDates: { colorIndex: OneToSeven; date: number }[] = [
  { colorIndex: 7, date: 15 },
  { colorIndex: 2, date: 2 },
  { colorIndex: 3, date: 6 },
  { colorIndex: 5, date: 8 },
  { colorIndex: 4, date: 19 },
  { colorIndex: 6, date: 18 },
  { colorIndex: 1, date: 3 },
  { colorIndex: 5, date: 16 },
  { colorIndex: 2, date: 1 },
  { colorIndex: 3, date: 12 },
  { colorIndex: 6, date: 23 },
  { colorIndex: 4, date: 9 },
  { colorIndex: 2, date: 14 },
  { colorIndex: 1, date: 20 },
  { colorIndex: 5, date: 5 },
  { colorIndex: 7, date: 24 },
  { colorIndex: 6, date: 17 },
  { colorIndex: 2, date: 7 },
  { colorIndex: 1, date: 4 },
  { colorIndex: 3, date: 10 },
  { colorIndex: 4, date: 21 },
  { colorIndex: 6, date: 13 },
  { colorIndex: 3, date: 22 },
  { colorIndex: 1, date: 11 },
];

export type FlexPropsWithoutAnimation = Omit<
  FlexProps,
  "animation" | "transition" | "transitionDuration" | "transitionProperty"
>;
